export enum InboundEmailStatus {
    New = "New", // email has been received by wb
    NotMatched = "Not Matched", // email has been rejected by config settings
    Matched = "Matched", // email has matched with a config setting
    Processing = "Processing", // email has been sent to the parser
    Failed = "Failed", // email failed to be imported
    Successful = "Successful" // email has been imported
}
